export default __webpack_public_path__ + "static/media/washingtondc.6318f129.jpg";